var cohort = {};
export {
  cohort as __exports
};
//# sourceMappingURL=cohort2.js.map
